import { ref, watch } from 'vue';
import { useTrack } from '@/hooks/useTrack';

export function useRule () {
  const showRule = ref(false);
  const { trackBtn } = useTrack();
  /**
   * 处理规则弹框滚动穿透的问题
   */
  watch(
    () => showRule.value,
    (curren) => {
      const body = document.body;
      if (curren) {
        body.style.overflow = 'hidden';
      } else {
        body.style.overflow = 'auto';
      }
    }
  );
  function openRule () {
    trackBtn('活动规则');
    showRule.value = true;
  }
  return {showRule, openRule };
}
